import { fromJS, List } from 'immutable';
import * as actions from '../utils/Constants'

const reducer = (state = getInitialState(), action) => {
    switch (action.type) {

        case actions.GET_PROGRAM + actions.FULFILLED:
            {
                return state.set('program', fromJS(action.payload));
            }
        case actions.UPDATE_PROGRAM + actions.FULFILLED:
            {
                return state.set('program', fromJS(action.payload));
            }
        case actions.CLEAR_PROGRAM_DATA: {
            return state.set('program', fromJS({ isActive: true }));
        }
        case actions.GET_PROGRAM_GRANTS + actions.FULFILLED: {
            return state.set('programGrants', action.payload);
        }
        case actions.SEARCH_GRANTS + actions.FULFILLED: {
            return state.set('searchedGrants', action.payload)
        }
        case actions.ADD_PROGRAM_GRANTS: {
            return state.set('searchedGrants', []);
        }
        case actions.TOGGLE_CONTACT_NAME_IS_VALID: {
            return state.set('contactNameIsValid', action.payload);
        }
        case actions.TOGGLE_CONTACT_PHONE_IS_VALID: {
            return state.set('phoneNumberIsValid', action.payload);
        }
        case actions.SET_SHOW_CASES: {
            return state.set('casesCheckbox', action.payload)
        }

        case actions.ADD_PROGRAM_DOCUMENT + actions.FULFILLED:
        case actions.DELETE_PROGRAM_DOCUMENTS + actions.FULFILLED:
        case actions.GET_PROGRAM_DOCUMENTS + actions.FULFILLED:
            {
                return state.set('documents', fromJS(action.payload));
            }
        case actions.MAKE_PRIMARY_CONTACT + actions.FULFILLED:
        case actions.ADD_PROGRAM_CONTACT + actions.FULFILLED:
        case actions.REMOVE_PROGRAM_CONTACTS + actions.FULFILLED:
        case actions.GET_PROGRAM_CONTACTS + actions.FULFILLED:
            {
                return state.set('contacts', fromJS(action.payload));
            }

        case actions.SET_PROGRAM_FIELD:
            return state.withMutations(mut => {
                return mut
                    .setIn(['program', action.field], action.payload)
            });

        case actions.SET_PROGRAM_ADDRESS_FIELD:
            return state.withMutations(mut => {
                var address = mut.getIn(['program', 'address'])
                if (!address) {
                    mut.setIn(['program', 'address'], {});
                }
                return mut.setIn(['program', 'address', action.field], action.payload)
            });

        case actions.SET_PROGRAM_PHONE_FIELD:
            return state.withMutations(mut => {
                var address = mut.getIn(['program', 'phone'])
                if (!address) {
                    mut.setIn(['program', 'phone'], {});
                }
                return mut.setIn(['program', 'phone'], action.payload)
            });

        case actions.NEW_PROGRAM:
            return getInitialState();
        case actions.SET_LOCATION: {
            return state.withMutations(mut => {
                return mut.update('fromTrainingPage', fromTrainngPage => !fromTrainngPage)
                    .set('fromTrainingId', action.payload)
            })
        }
        case actions.ADD_PROGRAM_POINTOFCONTACT:
            {
                return state.update('program', program => {
                    const contacts = program.get('contacts') || new List();
                    return program.set('contacts', contacts.push(fromJS({ person: action.payload })));
                });
            }

        case actions.GET_PROGRAM_JOURNAL + actions.FULFILLED:
        case actions.ADD_UPDATE_PROGRAM_JOUNALENTRY + actions.FULFILLED:
        case actions.DELETE_PROGRAM_JOUNALENTRIES + actions.FULFILLED:
            return state.set('journal', fromJS(action.payload));
        case actions.GET_PROGRAM_TRAININGS + actions.FULFILLED:
            return state.set('trainings', fromJS(action.payload));

        default:
            return state;
    }
}

const getInitialState = () => {
    return fromJS({
        program: { isActive: true },
        fromTrainingPage: false,
        fromTrainingId: '',
        contactPersonTypeIsValid: false,
        contacts: [],
        documents: [],
        journal: [],
        trainings: [],
        contactNameIsValid: false,
        phoneNumberIsValid: false,
        casesCheckbox: true,
    });
};

export default reducer;